import {
  TimeFrameRange,
  UpdateTimeFrameRangeBulkInput,
  UpdateTimeFrameRangeBulkResponse,
  UpdateTimeFrameRangeInput,
} from '@/models/gen/graphql';
import { Validation, generateUpdateBulkPayload } from '@/utils';

import { GraphApiResponse } from '@/api/core';
import { UpdateTimeFrameRangeBulkDocument } from '@/api/queries';
import { createTimeFrameRangeValidator } from './createTimeFrameRangeBulk';
import graphApi from '@/api';

type UpdateTimeFrameRangeBulkGraphApiResponse = GraphApiResponse<typeof UpdateTimeFrameRangeBulkDocument>;

const updateTimeFrameRangeValidator = new Validation.Validator(
  {
    'id!': (val: any): Validation.Validity => ({ valid: Validation.isValidUUID(val) }),
  },
  createTimeFrameRangeValidator
);

const updateTimeFrameRangeBulkResponseSelector = (res: UpdateTimeFrameRangeBulkGraphApiResponse): UpdateTimeFrameRangeBulkResponse =>
  !res.errors ? res?.updateTimeFrameRangeBulk : undefined;

const [runUpdateTimeFrameRangeBulk] = graphApi(UpdateTimeFrameRangeBulkDocument);

const updateTimeFrameRangeBulk = async (timeFrameRanges: Partial<TimeFrameRange>[]): Promise<UpdateTimeFrameRangeBulkResponse> => {
  timeFrameRanges = timeFrameRanges.map(
    (timeFrameRange: TimeFrameRange): TimeFrameRange => updateTimeFrameRangeValidator.partial(timeFrameRange)
  );
  const updates: UpdateTimeFrameRangeInput[] = generateUpdateBulkPayload(timeFrameRanges);
  const input: UpdateTimeFrameRangeBulkInput = {
    updates,
  };
  const res = await runUpdateTimeFrameRangeBulk({ input });

  return updateTimeFrameRangeBulkResponseSelector(res);
};

export default updateTimeFrameRangeBulk;
